<template>
  <d-container
    fluid
    class="main-content-container px-4">
    <!-- Page Header -->
    <d-row
      no-gutters
      class="page-header py-4">
      <d-col
        col
        sm="6"
        class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Urlopy</span>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja urlopu</template>
          <template v-else>Dodawanie urlopu</template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/urlopy')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          theme="success"
          :class="{isLoading : submitting}"
          @click.prevent="validateForm">
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab
            title="Dane urlopu"
            active>

            <validation-observer
              ref="vacations-form"
              tag="form"
              v-if="loaded">
              <h4 class="mb-3 pb-3 border-bottom">
                Data urlopu
              </h4>
              <d-row>
                <d-col>
                  <div class="form-group">
                    <label
                      for="name"
                      class="d-block">
                      Rozpoczęcie:
                    </label>
                    <validation-provider
                      rules="required"
                      name="start_at"
                      v-slot="{ errors }">
                      <date-picker
                        valueType="format"
                        type="date"
                        style="width: 200px;"
                        :class="{'invalid-date': errors.length }"
                        v-model="data.start_at"
                        :state="errors.length ? 'invalid' : null"
                        :placeholder="'Data od'"/>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col>
                  <div class="form-group">
                    <label
                      for="name"
                      class="d-block">
                      Zakończenie:
                    </label>
                    <validation-provider
                      rules="required"
                      name="end_at"
                      v-slot="{ errors }">
                      <date-picker
                        valueType="format"
                        type="date"
                        style="width: 200px;"
                        :class="{'invalid-date': errors.length }"
                        v-model="data.end_at"
                        :state="errors.length ? 'invalid' : null"
                        :placeholder="'Data do'"/>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
              <h4 class="mb-3 pb-3 border-bottom">
                Składanie zamówienia
              </h4>
              <d-row>
                <d-col>
                  <div class="form-group">
                    <label
                      for="name"
                      class="d-block">
                      Ostatnie możliwe zamówienie:
                    </label>
                    <validation-provider
                      rules="required"
                      name="last_possible_order_at"
                      v-slot="{ errors }">
                      <date-picker
                        valueType="format"
                        type="date"
                        style="width: 200px;"
                        :class="{'invalid-date': errors.length }"
                        v-model="data.last_possible_order_at"
                        :state="errors.length ? 'invalid' : null"
                        :placeholder="'Data od'"/>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col>
                  <div class="form-group">
                    <label
                      for="name"
                      class="d-block">
                      Najbliższa możliwa dostawa
                    </label>
                    <validation-provider
                      rules="required"
                      name="closest_possible_order_at"
                      v-slot="{ errors }">
                      <date-picker
                        valueType="format"
                        type="date"
                        style="width: 200px;"
                        :class="{'invalid-date': errors.length }"
                        v-model="data.closest_possible_order_at"
                        :state="errors.length ? 'invalid' : null"
                        :placeholder="'Data do'"/>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
              <h4 class="mb-3 pb-3 border-bottom">
                Wyświetlanie
              </h4>
              <d-row>
                <d-col>
                  <div class="form-group">
                    <label
                      for="name"
                      class="d-block">
                      Rozpoczęcie wyświetlania
                    </label>
                    <validation-provider
                      rules="required"
                      name="start_showing_at"
                      v-slot="{ errors }">
                      <date-picker
                        valueType="format"
                        type="date"
                        style="width: 200px;"
                        :class="{'invalid-date': errors.length }"
                        v-model="data.start_showing_at"
                        :state="errors.length ? 'invalid' : null"
                        :placeholder="'Data od'"/>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col>
                  <div class="form-group">
                    <label
                      for="name"
                      class="d-block">
                      Zakończenie wyświetlania
                    </label>
                    <validation-provider
                      rules="required"
                      name="end_showing_at"
                      v-slot="{ errors }">
                      <date-picker
                        valueType="format"
                        type="date"
                        style="width: 200px;"
                        :class="{'invalid-date': errors.length }"
                        v-model="data.end_showing_at"
                        :state="errors.length ? 'invalid' : null"
                        :placeholder="'Data do'"/>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
              <hr>
              <d-row>
                <d-col>
                  <div class="form-group">
                    <label for="description">
                      Opis
                    </label>
                    <validation-provider
                      name="description"
                      v-slot="{ errors }">
                      <textarea
                        class="form-control"
                        :state="errors.length ? 'invalid' : null"
                        type="text"
                        v-model="data.description"></textarea>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
            </validation-observer>
            <div
              v-if="!loaded"
              class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>
            <d-alert
              v-if="load_error"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a
                href="javascript:window.location.reload();"
              class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import DatePicker from 'vue2-datepicker';

export default {
  name: 'vacations-form',
  components: {
    DatePicker,
  },
  data () {
    return {
      data: {
        id: 0,
        start_at: '',
        end_at: '',
        last_possible_order_at: '',
        closest_possible_order_at: '',
        start_showing_at: '',
        end_showing_at: '',
        description: ''
      },
      submitting: false,
      loaded: false,
      load_error: false,
    };
  },
  computed: {
    isEdit () {
      return !!this.$route.params.id;
    },
  },
  mounted () {
    if (this.isEdit) {
      this.loadItemData();
    } else {
      this.loaded = true;
    }
  },
  methods: {
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/vacations/item/',
        instanceFields: ['start_at', 'end_at', 'last_possible_order_at', 'closest_possible_order_at', 'start_showing_at', 'end_showing_at', 'description'],
        loadedKey: 'loaded'
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['vacations-form']);
      FormUtils.validate(this.$refs['vacations-form'], this.submitForm);
    },
    submitForm () {
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = this.isEdit ? '/vacations/update/' + this.id : '/vacations/store';
      this.submitting = true;
      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano urlop',
        successText: 'Wybrany urlop został zapisany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja urlopu nie powiodła się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/urlopy');
          this.submitting = false;
        },
        failureAction: () => {
          this.submitting = false;
        }
      });
    },
    prepareFormDataToSend () {
      return {
        start_at: this.data.start_at,
        end_at: this.data.end_at,
        last_possible_order_at: this.data.last_possible_order_at,
        closest_possible_order_at: this.data.closest_possible_order_at,
        start_showing_at: this.data.start_showing_at,
        end_showing_at: this.data.end_showing_at,
        description: this.data.description
      };
    }
  }
};
</script>
